let $body, $window, layers, $wrapper, $yearSelect;

let $revealHiddenEvents;
let $newsLetterBlocks;

$(document).ready(function ($) {
  console.log(
    "%cLinku Novio",
    "font-size: 2em; font-family: sans-serif; color: white; background-color:#18aaff; padding:4px 8px; border-radius: 4px"
  );

  $body = $("body");
  $header = $(".js-header");
  $wrapper = $(".js-wrapper");
  $window = $(window);
  $yearSelect = $(".js-archive-year-select");
  $revealHiddenEvents = $(".js-reveal-event");

  // Add body class when page is loaded
  $body.addClass("is-loaded");

  hamburgerNavBackgroundOnScroll();

  $yearSelect.on("change", function () {
    var val = $(this).val();
    var url = $(this).attr("data-url");
    window.location.href = url + val;
  });

  $revealHiddenEvents.on("click", function () {
    let $parent = $(this).parent();
    let $itemContainer = $parent
      .prev()
      .children(".js-hidden-event")
      .removeClass("is-hidden");
    $(this).hide();
    LayerSystem.update();
  });

  AddSmoothScrollToSoldOut();

  Global.init();
  LayerSystem.init();
  EventTopFilter.init();
  ProgramTopFilter.init();
  hoverIconNewsletterBlock();
  LayerSystem.update();
});

const Global = (function () {
  const debug = {
    disableLayers: false,
    disableTopbar: false,
  };

  function initDebugging() {
    debug.disableLayers =
      getParameterByName("disableLayers") == "true" || false;
    debug.disableTopbar =
      getParameterByName("disableTopbar") == "true" || false;
  }

  function init() {
    initDebugging();
  }

  return {
    init,
    debug,
  };
})();

$("video").on("loadeddata", function () {
  LayerSystem.update();
});

function hamburgerNavBackgroundOnScroll() {
  ScrollTrigger.create({
    id: "hamburger-nav",
    trigger: $(".js-wrapper"),
    start: () => "top+=100 top",
    end: "bottom+=100 bottom",
    onToggle: (self) => {
      if (self.isActive) {
        $header.addClass("is-scrolling");
      } else {
        $header.removeClass("is-scrolling");
      }
    },
  });
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
function animateNewsletterShapes() {
  $(".js-newsletter-shape-1").each(function () {
    var $this = $(this);
    if ($this.isInViewport()) {
      $this.addClass("is-animated");
    }
  });
}

function hoverIconNewsletterBlock() {
  $newsLetterBlocks = $(".js-newsletter");

  $newsLetterBlocks.each(function () {
    let $input = $(this).find(".gfield input");

    $input.on("focus", function () {
      $(this).parent().addClass("is-focused");

      // TODO: fix hiervoor zoeken.
      // let vwWidth = $(window).width();
      // if (vwWidth < 1024){
      //   let $offsetTop = $(this).parents('.js-newsletter').position().top;
      //   let $top = parseInt($(this).parents('.js-layer').css('top'), 10);
      //   let scrollTarget = $offsetTop + $top - 200;
      //   $('html, body').animate({scrollTop: scrollTarget }, 'slow');
      // }
    });

    $input.on("focusout", function () {
      $(this).parent().removeClass("is-focused");
    });
  });
}

function AddSmoothScrollToSoldOut() {
  let $soldouts = $(".js-soldout");

  $soldouts.each(function () {
    $(this).find(".js-soldout-content a").addClass('js-smoothscroll');
  });
}

$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return "mobile";
  }
  return "desktop";
};

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
